export default __webpack_public_path__ + "static/media/Online-Event-tag.69fbe57f.svg";